import EventEmitter from 'eventemitter3'

class RoomEventEmitter extends EventEmitter {}

export const createRoomEventEmitter = () => {
    const roomEventEmitter = new RoomEventEmitter()

    return roomEventEmitter
}

export const roomEventEmitter = createRoomEventEmitter()
